export const messages = {
  pl: {
    message: {
      title: "Cennik PULSAR",
      titleMW: "Cennik MEAN WELL",
      //clause:
        //"Podane ceny to ceny detaliczne netto. Cennik nie stanowi oferty handlowej w rozumieniu Kodeksu Cywilnego.",
      clause1:
        "Podane ceny to ceny detaliczne netto.",
      clause2:
         "Podane ceny nie stanowią oferty handlowej wg art. 66 par. 1 Kodeksu Cywilnego i są publikowane tylko w celach informacyjnych. Podane ceny mogą ulec zmianie. Zastrzegamy sobie prawo do zmian.",
      clause3:
         "Cennik {version} obowiązuje od dnia {data_start}",
      clause4:
        " do dnia wejścia w życie nastepnego wydania. Zastępuje i unieważnia poprzednie wersje cenników. ",
      clause5:
        "Cennik wygenerowany: {data}",
      loading: "Ładowanie danych",
      download_pricelist: "Wygeneruj cennik wg. własnych kryteriów",
      set_discount: "Rabat",
      sales: "Wyprzedaże",
      sales_price: "cena nie podlega rabatowaniu",
      close: "Zamknij",
      search_engine: "Wyszukiwarka",
      searching: "Wyszukiwanie",
      no_results: "Brak wyników",
      no_results_sales: "brak produktów na wyprzedaży",
      no_results_rises: "brak produktów po podwyżce",
      no_results_reductions: "brak produktów po obniżce",
      no_results_news: "brak nowych produktów",
      no_results_phone: "brak produktów na telefon/mail",
      no_results_promotions: "brak nowych promocji",
      add_to_favorites: "Dodaj do ulubionych",
      add_to_favorites_html: "Dodaj do <strong>ulubionych</strong>.",
      add_to_favorites_text:
        "Umożliwi to wygenerowanie cennika tylko produktami dodanymi do ulubionych.",
      delete_from_favorites: "<p>Usuń <strong>ulubionych</strong>.</p>",
      delete_from_favorites_text: "<p>Usuń <strong>ulubionych</strong>.</p>",
      delete: "Usuń",
      export_to: "Eksport do {format}",
      separator: "Separator",
      semicolon: "Średnik",
      comma: "Przecinek",
      columns: "Kolumny",
      download: "Pobierz",
      download_full_pdf: "cennik detaliczny",
      download_full_pdf_dystrybutor: "cennik dla Dystrybutora",
      cancel: "Anuluj",
      pdf_file_generate: "Generowanie pliku PDF",
      pdf_file_generate_text: "Proszę czekać, trwa generowanie pliku PDF.",
      show_product: "Zobacz produkt",
      search_input_placeholder:
        "Proszę wpisać kod produktu np.: AWO000 lub nazwę np.: zasilacz buforowy",
      favourites: "Ulubione",
      categories: "Kategorie",
      favourites_text:
        "Teraz można swobodnie przełączać się pomiędzy produktami ulubionymi a wszystkimi produktami",
      all_products: "Wszystkie produkty",
      show_favourites_list: "Pokaż listę ulubionych",
      informations: "Informacje",
      parameters: "Parametry",
      table_of_contents: "Spis treści",
      show_parameters: "Pokaż parametry",
      product_code: "Kod produktu",
      product_name: "Nazwa produktu",
      price: "Cena",
      price_sale: "Cena poprzednia",
      price_dealer: "Cena dystrybutora",
      description: "Opis",
      ean_code: "Kod EAN",
      pcn_code: "Kod PCN",
      coo: 'Kraj pochodzenia',
      producer: "Producent",
      weight: "Waga",
      dimensions: "Wymiary",
      size: "Objętość [dm3]",
      product_photo: "Zdjęcie produktu",
      sale: "WYPRZEDAŻ",
      netto: "netto",
      rise: "PODWYŻKA",
      rises: "Podwyżki",
      reduction: "OBNIŻKA",
      reductions: "Obniżki",
      photo: "Zdjęcie",
      discount: "{discount}% rabatu",
      columns_text: "Kliknij aby edytować nazwy kolumn w wyeksportowanym pliku",
      net_detail: "netto detal",
      news: "Nowości",
      new: "NOWOŚĆ",
      phoneprice: "Cena produktu dostępna na telefon / email",
      only_letters_and_numbers: "Tylko litery i cyfry",

      login_form: "Logowanie",
      login: "Zaloguj się",
      logout: "Wyloguj",
      register: "Zarejestruj się",
      lost_pass: "Przypomnij hasło",
      email: "e-Mail",
      pass: "Hasło",
      pass_repeat: "Powtórz hasło",
      new_pass: "Nowe hasło",
      new_pass_repeat: "Powtórz nowe hasło",

      regi_form: "Rejestracja użytkownika",
      name: "Imię",
      surname: "Nazwisko",
      position: "Stanowisko",
      company: "Nazwa firmy",
      city: "Miasto",
      street: "Ulica, numer domu / numer lokalu",
      zip: "Kod pocztowy",
      nip: "NIP",
      country: "Kraj",
      phone: "Telefon",
      anuluj: "wróć",
      send: "Wyślij",
      select_coutry: "Wybierz kraj",
      send_mail: "Wysłaliśmy e-mailem link do resetowania hasła!",
      problem_with_db: "Problem z plączeniem do bazy",
      change: "zmień",
      rodo:
        "Na podstawie przepisu art. 6 ust 1 lit. a ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 roku wyrażam zgodę na przetwarzanie moich danych osobowych w postaci imienia, nazwiska, numeru telefonu, adresu e- mail, adresu IP w celach dostępu do cennika online przez PULSAR K.BOGUSZ spółka jawna. Jednocześnie oświadczam, iż zostałem poinformowany o możliwości cofnięcia zgody w każdym czasie.",
      infoText:
        "Dziękujemy za rejestrację, poinformujemy Cię o dostępie przez e-mail.",
      accessDenied: "Złe dane lub brak dostępu do logowania.",
      infochangepass: "Zmiana przeszła pomyślnie. Wróć do logowania.",
      required: "pola wymagane",
      profil: "Profil",
      actualize: "Aktualizuj",
      user_profile: "Profil uzytkownika",
      infoTextChangePass: "Twoje hasło zostało zmienione pomyślnie!",
      linkImg: "Link Zdjęcia",
      linkKK: "Link Karty",
      titleKK: "karta katalogowa",
      titleWWW: "zobacz na stronie www",
      uups: "Uuups! Prace serwisowe",
      dosnt_work_sorry: "Za utrudnienia przepraszamy",
      finished_service:"Planowane zakończenie prac serwisowych na dzień:",
      summary_tables:"Zestawienie tabel",
      show_summary_tables:"pokaż zestawienie",
      promotions: "Promocja",
      warranty: 'Gwarancja',
      package: 'Opakowanie',
      soon: 'wkrótce w ofercie',
      download_file: 'Pobierz pliki',
      cennik_detal: 'Cennik Pulsar',
      cennik_detal_mw: 'Cennik Mean Wel',
      cennik_pulsar: 'cennik Pulsar',
      cennik_mw: 'cennik Mean Well',
      pricelist_update: 'TRWA AKTUALIZACJA CENNIKA',
      data_stop_service: 'Data zakończenia: '
    }
  },
  en: {
    message: {
      title: "PULSAR pricelist",
      titleMW: "MEAN WELL pricelist",
      // clause:
      //   "The prices given are net retail prices. The price list does not constitute an offer within the meaning of the Civil Code.",
      clause1:
        //"Podane ceny to ceny detaliczne netto. Cennik nie stanowi oferty handlowej w rozumieniu Kodeksu Cywilnego.",
        "Prices given are net retail prices.",
      clause2:
         "",
      clause3:
         "Pricelist {version} is valid from {data_start}",
      clause4:
        "",
      clause5:
        "Pricelist generated: {data}",
      loading: "Loading",
      download_pricelist: "Generate pricelist",
      set_discount: "Discount",
      sales: "Sales",
      sales_price: "no discount applicable",
      close: "Close",
      search_engine: "Search engine",
      searching: "Searching",
      no_results: "No results",
      no_results_sales: "no products on sale",
      no_results_rises: "no products after a raise",
      no_results_reductions: "no products after discount",
      no_results_news: "no new products",
      no_results_promotions: "no new promotions",
      no_results_phone: "no products on the phone / mail",
      add_to_favorites: "Add to favorites",
      add_to_favorites_html: "Add to <strong>favorites</strong>.",
      add_to_favorites_text:
        "This will allow you to generate a price list only with products added to your favorites",
      delete_from_favorites: "Delete from <strong>favorites</strong>.",
      delete_from_favorites_text:
        "Attention! This will remove all child categories from the favorites",
      delete: "Delete",
      export_to: "Export to {format}",
      separator: "Separator",
      semicolon: "Semicolon",
      comma: "Comma",
      columns: "Columns",
      download: "Download",
      download_full_pdf: "download full price list",
      download_full_pdf_dystrybutor: "Pricelist for Distributor",
      cancel: "Cancel",
      pdf_file_generate: "Generating a PDF file",
      pdf_file_generate_text: "Please wait, the PDF file is being generated",
      show_product: "Show product",
      search_input_placeholder:
        "Please enter the product code, eg: AWO000 or the name, eg buffer power supply",
      favourites: "Favourites",
      categories: "Categories",
      favourites_text:
        "Now you can freely switch between your favorite products and all products",
      all_products: "All products",
      show_favourites_list: "Show favourites list",
      informations: "Information",
      parameters: "Parameters",
      table_of_contents: "Table of contents",
      show_parameters: "Show parameters",
      product_code: "Product code",
      product_name: "Product name",
      price: "Price",
      price_sale: "Sale price",
      price_dealer: "Dealer price",
      description: "Description",
      ean_code: "EAN code",
      pcn_code: "PCN code",
      coo: 'Country',
      producer: "Producer",
      weight: "Weight",
      dimensions: "Dimensions",
      size: "Volume [dm3]",
      product_photo: "Product photo",
      sale: "SALE",
      netto: "net",
      rise: "RISE",
      rises: "Rises",
      reduction: "REDUCTION",
      reductions: "Reductions",
      photo: "Photo",
      discount: "{discount}% discount",
      columns_text: "Click to edit column names in the exported file",
      net_detail: "net detail",
      news: "News",
      new: "NEW",
      phoneprice: "Please contact us",
      only_letters_and_numbers: "Only letters and numbers",
      login_form: "Login Form",
      login: "Log in",
      logout: "Log out",
      register: "Register",
      lost_pass: "Lost your password?",
      email: "E-mail",
      pass: "Password",
      pass_repeat: "Confirm password",
      new_pass: "New password",
      new_pass_repeat: "Confirm new password",

      regi_form: "Create an account",
      name: "Name",
      surname: "Surname",
      position: "Position",
      company: "Company name",
      country: "Country",
      city: "Miasto / Oddział",
      street: "Ulica, numer domu / numer lokalu",
      zip: "Kod pocztowy",
      nip: "NIP",
      phone: "Phone",
      anuluj: "back",
      send: "Send",
      select_coutry: "Select country",
      send_mail: "We have sent you a password reset link by e-mail!",
      problem_with_db: "Problem with connecting to the database.",
      change: "change",
      rodo:
        "Pursuant to the provision of Article 6 (1) a of the General Regulation on Personal Data Protection of 27th April 2016, I consent to the processing of my personal data in the form of name, surname, phone number, e-mail address and IP for access to online pricelist and marketing purposes by PULSAR K.BOGUSZ spółka jawna. At the same time, I declare that I have been informed about the possibility of withdrawing my consent at any time.",
      infoText:
        "Thank You for registration.\nWe will inform You about access by email.",
      accessDenied: "Bad data or no login access.",
      infochangepass: "The change has been successful. Return to login.",
      required: "required",
      profil: "Profile",
      actualize: "actualize",
      user_profile: "User profile",
      infoTextChangePass: "Success! Your Password has been changed!",
      linkImg: "Image Link",
      linkKK: "Data Sheet Link",
      titleKK: "Data sheet",
      titleWWW: "see the website",
      uups: "Uuups! Service work",
      dosnt_work_sorry: "We apologize for the inconvenience",
      finished_service: "Scheduled completion of service work per day:",
      summary_tables:"Summary of tables",
      show_summary_tables:"show summary",
      promotions: "Promotions",
      warranty: 'Warranty',
      package: 'Package',
      soon: 'available soon',
      download_file: 'Download file',
      cennik_detal: 'Pricelist Pulsar',
      cennik_detal_mw: 'Pricelist Mean Well',
      cennik_pulsar: 'Pulsar pricelist ',
      cennik_mw: 'Mean Well pricelist',
      pricelist_update: 'PRICE LIST UPDATING',
      data_stop_service: 'End date: '
    }
  }
};



// WEBPACK FOOTER //
// ./src/translations/messages.js